import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {FigureControlOptions} from "./Controls/FigureControl.Options";
import {QRControlOptions} from "./Controls/QRControl.Options";
import {FigureControl} from "./Controls/FigureControl";
import {QRControl} from "./Controls/QRControl";
import {IconControl} from "./Controls/IconControl";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {HtmlControlOptions} from "./Controls/HtmlControl.Options";
import {HtmlControl} from "./Controls/HtmlControl";
import {IconControlOptions} from "./Controls/IconControl.Options";
import {ImageControlOptions} from "./Controls/ImageControl.Options";
import {ImageControl} from "./Controls/ImageControl";


export class PRPDFControlFactory {
    static GetControl(controlType:string):PDFControlBase
    {
        switch (controlType) {
            case PRControlTypes.Figure:
                return new FigureControl();
            case PRControlTypes.Icon:
                return new IconControl();
            case PRControlTypes.QRCode:
                return new QRControl();
            case PRControlTypes.HTML:
                return new HtmlControl();
            case PRControlTypes.Image:
                return new ImageControl();
            default:
                return null;
        }
    }


}

export class PRPDFControlOptionsFactory{
    static GetControlOptions(type:string)
    {
        switch (type) {
            case PRControlTypes.Figure:
                return new FigureControlOptions();
            case PRControlTypes.Icon:
                return new IconControlOptions();
            case PRControlTypes.QRCode:
                return new QRControlOptions();
            case PRControlTypes.HTML:
                return new HtmlControlOptions();
            case PRControlTypes.Image:
                return new ImageControlOptions();
            default:
                return null;
        }
    }


}




export enum PRControlTypes{
    QRCode='QRCode',
    Icon='Icon',
    Figure='Figure',
    HTML="HTML",
    Image="Image"
}